import { render, staticRenderFns } from "./SearchResults.vue?vue&type=template&id=59286472"
import script from "./SearchResults.vue?vue&type=script&lang=ts"
export * from "./SearchResults.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports